import isEqual from 'lodash/isEqual';
import { useState, useCallback, useEffect } from 'react';
// @mui
import { alpha } from '@mui/material/styles';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Card from '@mui/material/Card';
import Table from '@mui/material/Table';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Container from '@mui/material/Container';
import TableBody from '@mui/material/TableBody';
import IconButton from '@mui/material/IconButton';
import TableContainer from '@mui/material/TableContainer';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
// _mock
import { _userList, _roles, USER_STATUS_OPTIONS, USER_STATUS_OPTIONS_ROLE } from 'src/_mock';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// components
import Label from 'src/components/label';
import Iconify from 'src/components/iconify';
import Scrollbar from 'src/components/scrollbar';
import { ConfirmDialog } from 'src/components/custom-dialog';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import {
    useTable, emptyRows, TableEmptyRows,
    TableHeadCustom,
    TableSelectedAction
} from 'src/components/table';

import { getRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { TradesWorkTitleCreate } from './create-twt-modal';
import TablePaginationApiBased from 'src/components/table/table-pagination-api-based-urls';
import UserTableToolbar from './twt-table-toolebar';
import UserTableFiltersResult from './twt-table-filter';
import UserTableRow from './twt-table-row';
import { Box } from '@mui/material';
import { LoadingScreen } from 'src/components/loading-screen';

//

// ----------------------------------------------------------------------

const STATUS_OPTIONS = [ { value: 'all', label: 'All' }, ...USER_STATUS_OPTIONS ];

const TABLE_HEAD = [
    { id: 'name', label: 'Title Code' },
    { id: 'name', label: 'Name' },
    { id: 'phoneNumber', label: 'Category', width: 180 },
    { id: 'phoneNumber', label: 'Base Wages', width: 180 },
    { id: 'phoneNumber', label: 'Suppl.Benefits', width: 180 },
    { id: 'phoneNumber', label: 'Employee  Taxes', width: 180 },
    { id: 'phoneNumber', label: 'Work Comp Insurance', width: 180 },
    { id: 'phoneNumber', label: 'Misc Expanses', width: 180 },
    { id: 'phoneNumber', label: 'Regular Time Rate ', width: 180 },
    { id: 'phoneNumber', label: 'Over Time Rate ', width: 180 },
    { id: 'phoneNumber', label: 'Double Time Rate ', width: 180 },
    { id: 'phoneNumber', label: 'Actions ', width: 180 },
    { id: '', width: 88 },
];
const defaultFilters = {
    name: '',
    role: [],
    status: 'all',
    active: 'all',
};

// ----------------------------------------------------------------------

export default function TradesWorkTitleTable() {

    const [ tableData, setTableData ] = useState();
    console.log(tableData, 'tableData')
    const [ loading, setLoading ] = useState(false);

    const table = useTable();
    const settings = useSettingsContext();
    const router = useRouter();
    const confirm = useBoolean();
    const add = useBoolean();


    useEffect(() => {
        getTradeWorkTitle();
    }, [ table.page, table.rowsPerPage ]);

    const getTradeWorkTitle = async (page = 1) => {
        const params = `?page=${page}`;
        setLoading(true)

        const data = await getRequest(`${endpoints.admin_dashboard.teachnical_database.trade_work_title.get_list}${params}`);
        if (data) {
            console.log("🚀 ~ getTradeWorkTitle ~ data:", data)
            setTableData(data || []);
        }
        setLoading(false)

    };

    const [ filters, setFilters ] = useState(defaultFilters);
    const denseHeight = table.dense ? 52 : 72;

    const canReset = !isEqual(defaultFilters, filters);
    const notFound = (!tableData?.length && canReset) || !tableData?.length;


    const handleFilters = useCallback(
        (name, value) => {
            table.onResetPage();
            setFilters((prevState) => ({
                ...prevState,
                [ name ]: value,
            }));
        },
        [ table ]
    );

    const handleEditRow = useCallback(
        (id) => {
            router.push(paths.dashboard.user.edit(id));
        },
        [ router ]
    );

    const handleFilterStatus = useCallback(
        (event, newValue) => {
            handleFilters('status', newValue);
        },
        [ handleFilters ]
    );

    const handleResetFilters = useCallback(() => {
        setFilters(defaultFilters);
    }, []);

    return (
        <>
            { loading ? (
                <Box height={ 700 }>
                    <LoadingScreen />
                </Box>
            ) : (
                <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
                    <CustomBreadcrumbs
                        heading="Trade Work Title"
                        links={ [
                            { name: '', href: paths.dashboard.root },

                        ] }
                        action={
                            <Button
                                onClick={ () => add.onTrue() }
                                variant="contained"
                                startIcon={ <Iconify icon="mingcute:add-line" /> }
                            >
                                Create
                            </Button>

                        }
                        sx={ {
                            mb: { xs: 3, md: 5 },
                        } }
                    />
                    <Card>
                        <Tabs
                            value={ filters.status }
                            onChange={ handleFilterStatus }
                            sx={ {
                                px: 2.5,
                                boxShadow: (theme) => `inset 0 -2px 0 0 ${alpha(theme.palette.grey[ 500 ], 0.08)}`,
                            } }
                        >
                            { USER_STATUS_OPTIONS_ROLE.map((tab) => (
                                <Tab
                                    key={ tab.value }
                                    iconPosition="end"
                                    value={ tab.value }
                                    label={ tab.label }
                                    icon={
                                        <Label
                                            variant={
                                                ((tab.value === 'all' || tab.value === filters.status) && 'filled') || 'soft'
                                            }
                                            color={
                                                (tab.value === 'active' && 'success') ||
                                                'default'
                                            }
                                        >
                                            { tab.value === 'all' && _userList.length }
                                            { tab.value === 'active' &&
                                                _userList.filter((user) => user.status === 'active').length }

                                            { tab.value === 'inactive' &&
                                                _userList.filter((user) => user.status === 'inactive').length }

                                        </Label>
                                    }
                                />
                            )) }
                        </Tabs>
                        <UserTableToolbar
                            filters={ filters }
                            onFilters={ handleFilters }
                            //
                            roleOptions={ _roles }
                            reload={ () => getTradeWorkTitle() }
                        />
                        { canReset && (
                            <UserTableFiltersResult
                                filters={ filters }
                                onFilters={ handleFilters }
                                //
                                onResetFilters={ handleResetFilters }
                                //
                                results={ tableData?.length }
                                sx={ { p: 2.5, pt: 0 } }
                            />
                        ) }
                        <TableContainer sx={ { position: 'relative', overflow: 'unset' } }>
                            <TableSelectedAction
                                dense={ table.dense }
                                numSelected={ table?.selected.length }
                                rowCount={ tableData?.length }
                                onSelectAllRows={ (checked) =>
                                    table.onSelectAllRows(
                                        checked,
                                        tableData?.map((row) => row.id)
                                    )
                                }
                                action={
                                    <Tooltip title="Delete">
                                        <IconButton color="primary" onClick={ confirm.onTrue }>
                                            <Iconify icon="solar:trash-bin-trash-bold" />
                                        </IconButton>
                                    </Tooltip>
                                }
                            />
                            <Scrollbar>
                                <Table size={ table.dense ? 'small' : 'medium' } sx={ { minWidth: 960 } }>
                                    <TableHeadCustom
                                        order={ table?.order }
                                        orderBy={ table?.orderBy }
                                        headLabel={ TABLE_HEAD }
                                        rowCount={ tableData?.length }
                                        numSelected={ table?.selected.length }
                                        onSort={ table?.onSort }
                                        onSelectAllRows={ (checked) =>
                                            table?.onSelectAllRows(
                                                checked,
                                                tableData?.map((row) => row.id)
                                            )
                                        }
                                    />
                                    <TableBody>
                                        { tableData?.data?.map((row) => (
                                            <UserTableRow
                                                key={ row.id }
                                                row={ row }
                                                selected={ table.selected.includes(row.id) }
                                                onSelectRow={ () => table.onSelectRow(row.id) }
                                                // onDeleteRow={ () => handleDeleteRow(row.id) }
                                                onEditRow={ () => handleEditRow(row.id) }
                                            />
                                        )) }
                                        <TableEmptyRows
                                            height={ denseHeight }
                                            emptyRows={ emptyRows(table?.page, table?.rowsPerPage, tableData?.length) }
                                        />

                                        {/* <TableNoData notFound={ notFound } /> */ }
                                    </TableBody>
                                </Table>
                            </Scrollbar>
                        </TableContainer>
                        <TablePaginationApiBased
                            // dense={ dense }
                            // onChangeDense={ handleDenseChange }
                            paginationLinks={ tableData }
                            onPageChange={ (page) => getTradeWorkTitle(page) }
                        />

                    </Card>
                </Container>
            ) }
            <TradesWorkTitleCreate
                open={ add.value } onClose={ add.onFalse }
                reload={ () => getTradeWorkTitle() }
            />
            <ConfirmDialog
                open={ confirm.value }
                onClose={ confirm.onFalse }
                title="Delete"
                content={
                    <>
                        Are you sure want to delete <strong> { table.selected.length } </strong> items?
                    </>
                }
                action={
                    <Button
                        variant="contained"
                        color="error"
                        onClick={ () => {
                            // handleDeleteRows();
                            confirm.onFalse();
                        } }
                    >
                        Delete
                    </Button>
                }
            />
        </>
    );
}

// ----------------------------------------------------------------------

